import { StyledAboutSection } from "./styles";

const AboutSection = () => {
  return (
    <StyledAboutSection id="about">
      <div
        className="agentify"
        style={{
          alignItems: "stretch",
        }}
      >
        <div>
          <span className="section-label">Our story</span>

          <h2 className="section-title">
            Built from a problem we lived every day.
          </h2>

          <p className="section-sub-title">
            Messaging has become the primary way businesses communicate with
            customers. What used to happen over phone calls and email now starts
            with a chat.
          </p>

          <p style={{ color: "#6f687e" }}>
            I experienced this first-hand. Insurance agents, mortgage brokers,
            gardeners, startup partners everyone preferred messaging me on
            WhatsApp. Late-night business messages and promotional broadcasts
            were mixed with conversations from family and friends, and I
            couldn't tell where work ended and personal life began.
          </p>

          <p style={{ color: "#6f687e" }}>
            <strong style={{ color: "#17141f" }}>So I built Kelu.</strong> It
            started as a way to separate business communication from personal
            messaging, but I quickly realised conversations were only the
            beginning. Every customer message led to meetings, tasks, documents
            and follow-ups spread across multiple apps. The real problem wasn't
            messaging it was that businesses had no single place where customer
            work happened.
          </p>

          <p style={{ color: "#6f687e" }}>
            Today, my team and I run both of our startups entirely on Kelu and
            the team loves it. Customer conversations, internal collaboration,
            meetings, tasks, documents and AI all live in one workspace. We
            built Kelu because we needed it ourselves and now we can't imagine
            working without it.
          </p>

          <p
            style={{
              color: "#17141f",
              fontWeight: 750,
              marginBottom: 0,
            }}
          >
            Our vision is simple: every customer relationship should have one
            home, where people and AI work together from the first conversation
            to the final outcome.
          </p>
        </div>

        <div
          style={{
            borderRadius: "24px",
            background: "linear-gradient(145deg, #7654b5, #4db882)",
            display: "grid",
            placeItems: "center",
            color: "#fff",
            textAlign: "center",
            padding: "30px",
            boxShadow: "0 18px 40px rgba(70, 43, 115, 0.22)",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "56px",
                marginBottom: "12px",
              }}
            >
              👂
            </div>

            <div
              style={{
                fontSize: "30px",
                fontWeight: 850,
              }}
            >
              Built in London by Deepthi &amp; Girish.
            </div>

            <div
              style={{
                opacity: 0.88,
                marginTop: "12px",
                lineHeight: 1.6,
              }}
            >
              Kelu means “listen” in Kannada.
              <br />
              Built by founders who lived the problem.
            </div>
          </div>
        </div>
      </div>
    </StyledAboutSection>
  );
};

export default AboutSection;
